import { get, post } from '@/utils/request/mAxios';
import APIs from './index';
import {
  GetTeamMember, AddTeamMember,
  UpdateTeamMember, DeleteTeamMember,
} from '@/pages/home/type/teamType';

export function getTeamMember(data: GetTeamMember) {
  return get(APIs.getTeamMember, data);
}

export function getTeamRole() {
  return get(APIs.getTeamRole);
}

export function addTeamMember(data: AddTeamMember) {
  return post(APIs.addTeamMember, data);
}

export function updateTeamMember(data: UpdateTeamMember) {
  return post(APIs.updateTeamMember, data);
}

export function deleteTeamMember(data: DeleteTeamMember) {
  return post(APIs.deleteTeamMember, data);
}
